import { StylesConfig } from 'react-select';

export const SelectStyle: StylesConfig = {
  control: (css) => ({
    ...css,
    backgroundColor: 'white',
    borderRadius: '10px',
    border: '1px solid #C3CBDF',
    boxSizing: 'border-box',
    boxShadow: '0px',
  }),
  option: (css, { isFocused, isSelected }) => {
    let optionColor = isFocused ? '#E1E5EF' : '';
    if (isSelected) {
      optionColor = '#F0F2F7';
    }
    return {
      ...css,
      backgroundColor: optionColor,
      color: '#2B3230',
    };
  },
  menu: (css) => ({
    ...css,
    borderRadius: '5px',
  }),
};
